module.exports = __webpack_public_path__ + "static/media/essve-onboarding.5de47e29.jpg";